import React from "react";
import { useSelector, useDispatch } from "react-redux";

import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { TodoComp } from "../Todo/TodoComp";
import { Counter } from "../Counter/Counter";

export const ReduxState = () => {
  const reduxState = useSelector((state) => state);

  return (
    <div style={{ width: "80%", margin: "auto" }}>
        <h2 style={{textAlign:"center"}}>Redux basics</h2>
      <h6 style={{ justifyContent: "center", textAlign: "justify", marginTop:"1rem" }}>
        Store is a simple Object. In this demonstration, we are having two
        reducers <code>todoReducer</code> and <code>counterReducer</code>.
        <h6 style={{ display: "block", margin: "1rem 1rem 1rem 0rem " }}>
          These reducers are combined using <code>combineReducers()</code> from
          `redux`. Whenever we are updating the state by performing user events
          such as click event, we are indirectly triggering an action dispatch.
        </h6>
        <h6 style={{ display: "block", margin: "1rem 1rem 1rem 0rem " }}>
          Like, Counter + click dispatches an action 'INCREMENT' to the
          counterReducer, where the count state updated. Reducers takes the old
          state and action and returns a new state without mutating the state.
        </h6>
      </h6>

      <div style={{display:"flex", flexWrap:"wrap"}}>
        <div
          style={{
            marginTop: "1rem",
          }}
        >
          <Counter />
          <hr />
          <TodoComp />
        </div>
        <div
          style={{
            width: "60%",
            margin: "auto",
          }}
        >
          <div >
            <h6 style={{color:"tomato"}}> Below depicts, how the global state is updating based on the user actions:</h6>
            {reduxState ? (
              <JSONPretty id="json-pretty" data={reduxState}></JSONPretty>
            ) : (
              <div
                style={{
                  color: "red",
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                No State in Store
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
